<template>
  <div id="TrackerLayout">
    <div class="layout-container">
      <router-view
        :key="key" />
    </div>
  </div>
</template>
<script>

export default {
  name: 'Layout',
  data() {
    return {
      ticket: false,
      product: process.env.VUE_APP_PRODUCT,
      business: process.env.VUE_APP_BUSINESS
    }
  },
  computed: {
    key() {
      return this.$route.fullPath
    },
    poweredBy() {
      return 'Powered by Jelp Delivery ©2022'
    }
  }
}
</script>
